import { Alert, Box, Button, CircularProgress, Paper, Typography } from '@mui/material';
import React from 'react';

function Centered({ children }: { children: React.ReactNode }) {
  return (
    <Box sx={{ minHeight: '100vh', display: 'grid', placeItems: 'center', p: 2 }}>{children}</Box>
  );
}

export function SignInScreen({ onSignIn }: { onSignIn: () => void }) {
  return (
    <Centered>
      <Paper variant="outlined" sx={{ p: 4, textAlign: 'center' }}>
        <Typography variant="h5" component="h1" gutterBottom>
          Fides Registry
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Sign in with your Fides admin account.
        </Typography>
        <Button variant="contained" onClick={onSignIn}>
          Sign in
        </Button>
      </Paper>
    </Centered>
  );
}

export function AccessErrorScreen({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <Centered>
      <Alert
        severity="error"
        action={
          <Button color="inherit" size="small" onClick={onRetry}>
            Retry
          </Button>
        }
      >
        Could not load your Registry access: {message}
      </Alert>
    </Centered>
  );
}

export function LoadingScreen() {
  return (
    <Centered>
      <CircularProgress aria-label="Loading the Registry" />
    </Centered>
  );
}
